namespace Matrix.Data {
    export interface OwnershipBasisRow {
        OwnershipBasisCode?: string;
        Name?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace OwnershipBasisRow {
        export const idProperty = 'OwnershipBasisCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Data.OwnershipBasis';
        export const lookupKey = 'Data.OwnershipBasis';

        export function getLookup(): Q.Lookup<OwnershipBasisRow> {
            return Q.getLookup<OwnershipBasisRow>('Data.OwnershipBasis');
        }
        export const deletePermission = 'DataAdmin:OwnershipBasis';
        export const insertPermission = 'DataAdmin:OwnershipBasis';
        export const readPermission = 'Read:OwnershipBasis';
        export const updatePermission = 'DataAdmin:OwnershipBasis';

        export declare const enum Fields {
            OwnershipBasisCode = "OwnershipBasisCode",
            Name = "Name",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
